import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["innerHTML"];
import { tv } from 'tailwind-variants';
import { clsx } from 'clsx';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModalHeader',
    props: {
        size: {},
        title: {}
    },
    setup(__props) {
        const props = __props;
        const modalHeader = tv({
            slots: {
                base: 'desktop:pt-60 desktop:pl-40 desktop:pr-24 desktop:min-h-72 shrink-0',
                title: 'desktop:text-header-5 desktop:pb-20 desktop:pt-0 block py-4 text-gray-900',
            },
            variants: {
                size: {
                    small: 'min-h-56 pl-24 pr-16 pt-44',
                    large: 'min-h-64 pl-16 pr-16 pt-60',
                },
            },
        });
        const { base, title: titleClass } = modalHeader();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_unref(clsx)(_unref(base)({ size: props.size })))
            }, [
                (props.title)
                    ? (_openBlock(), _createElementBlock("strong", {
                        key: 0,
                        class: _normalizeClass(_unref(clsx)(_unref(titleClass)(), props.size === 'small' && 'text-title-2', props.size === 'large' && 'text-m-header-1 pb-20')),
                        innerHTML: props.title
                    }, null, 10, _hoisted_1))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "header")
            ], 2));
        };
    }
});
